import React from 'react'
import './Line.scss'
export const Line = () => {
    return (
        <div className="line-main-div">  
            
        </div>
    )
}
